import { getCookie } from '../../../utils';
import { ContactUsFormData } from '../types/ContactUsFormData';
import { formDataToPayload, payloadToFormDataObject } from './mapper';

const URL = '/api/v1/contact-us/';

export async function sendContactForm(data: ContactUsFormData): Promise<void> {
    const payload = formDataToPayload(data);
    const formData = payloadToFormDataObject(payload);
    addCSRFToken(formData);
    const headers = new Headers();
    headers.set('Content-Type', 'multipart/form-data');

    const response = await fetch(URL, {
        method: 'POST',
        body: formData,
    });
    if (response.status !== 200) throw new Error(`Bad request`);
}

function addCSRFToken(formData: FormData) {
    const csrftoken = getCookie('csrftoken') as string;
    formData.append('csrfmiddlewaretoken', csrftoken);
}
